import { styled } from '@mui/material';

import { linkable } from '../../routing';
import { colorSystem } from '../../theme';
import { BaseButton, LinkButton } from './BaseButton';

const destructivePrimaryButtonStyle = {
    color: colorSystem.neutral.white,
    background: colorSystem.red[7],
    border: `1px solid ${colorSystem.red[7]}`,

    '&:hover': {
        background: colorSystem.red[8],
    },
    '&:active': {
        background: colorSystem.red[9],
    },
    '&:disabled': {
        background: colorSystem.neutral[5],
        color: colorSystem.neutral.white,
        border: `1px solid ${colorSystem.neutral[5]}`,
    },
};

const DestructivePrimaryButtonHost = styled(BaseButton)(destructivePrimaryButtonStyle);
const DestructivePrimaryButtonLinkHost = styled(LinkButton)(destructivePrimaryButtonStyle);

export const DestructivePrimaryButton = linkable(DestructivePrimaryButtonHost, {
    linkHost: DestructivePrimaryButtonLinkHost,
});
